import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const ptBR: AppStrings = {
  // COMMON
  error_title: 'Erro',
  cancel: 'Cancelar',
  retry: 'Tentar novamente',
  back_arrow: '← Voltar',

  // ASK SCREEN
  ask_box_unavailable: 'Box indisponível',
  ask_box_unavailable_desc: 'O link pode estar desatualizado ou o dono fechou o box.',
  ask_create_own_box: 'Criar meu próprio box',
  ask_sent_title: 'Enviado ✅',
  ask_sent_desc: 'Sua pergunta anônima foi entregue ao dono do box.',
  ask_anonymous_hint: 'Sua pergunta será enviada anonimamente.',
  ask_placeholder: 'Escreva sua pergunta…',
  ask_send: 'Enviar',
  ask_sending: 'Enviando…',
  ask_error_rate_limit: 'Muitas requisições — aguarde um momento.',
  ask_error_restart: 'Por favor, reinicie o Mini App.',
  ask_error_load: 'Não foi possível carregar o box.',
  ask_error_send: 'Não foi possível enviar a pergunta.',
  ask_error_banned: 'Você está bloqueado no app.',
  ask_banned_appeal_btn: 'Recorrer',
  ask_appeal_sent: 'Recurso enviado. Vamos analisar manualmente.',

  // AGE GATE
  age_gate_title: 'Apenas maiores de 18',
  age_gate_desc:
    'Você está enviando uma pergunta anônima. Seja respeitoso: assédio, ameaças, conteúdo sexual envolvendo menores e qualquer conteúdo ilegal são proibidos. Anonimato não significa impunidade — violações são reportadas à moderação. Ao enviar uma pergunta, você confirma que tem 18+ e aceita as regras.',
  age_gate_confirm: 'Tenho 18+ — continuar',

  // INBOX SCREEN
  inbox_title: 'Meu box',
  box_link_accordion: 'Link de convite',
  inbox_notifications_ask: '🔔 Permitir que o bot envie notificações sobre novas perguntas?',
  inbox_notifications_allow: 'Permitir',
  inbox_notifications_dismiss_label: 'Dispensar',
  inbox_box_toggle_disable: 'Desativar perguntas',
  inbox_box_toggle_enable: 'Ativar perguntas',
  inbox_box_disabled_warning: 'Perguntas desativadas — nenhuma nova pergunta será aceita.',
  inbox_share_hint: 'Compartilhe o link para que seus amigos façam perguntas anônimas.',
  inbox_copy: 'Copiar',
  inbox_copied: 'Copiado',
  inbox_copy_error: 'Erro',
  inbox_no_deeplink: 'O link aparecerá após o deploy.',
  inbox_invite_story: 'Convidar via Story',
  inbox_invite_chat: 'Convidar via chat',
  inbox_card_rendering: 'O card de convite ainda está sendo gerado.',
  inbox_story_unsupported:
    'Stories não estão disponíveis nesta versão do Telegram. Tente "via chat".',
  inbox_story_error: 'Não foi possível abrir a Story.',
  inbox_chat_unsupported:
    'Compartilhamento via chat não está disponível nesta versão do Telegram. Atualize seu cliente.',
  inbox_chat_error: 'Não foi possível compartilhar. Tente novamente.',
  inbox_chat_prepare_error: 'Não foi possível preparar o convite.',
  inbox_filter_incoming: 'Recebidas',
  inbox_filter_hidden: 'Ocultas',
  inbox_filter_blocked: 'Bloqueadas',
  inbox_filter_empty: 'Nada aqui ainda.',
  inbox_acc_unanswered: 'Sem resposta',
  inbox_acc_answered: 'Respondidas',
  inbox_acc_hidden: 'Ocultas',
  inbox_acc_blocked: 'Bloqueadas',
  inbox_empty: 'Ainda sem perguntas. Compartilhe o link acima.',
  inbox_load_more: 'Carregar mais',
  inbox_load_more_error: 'Não foi possível carregar a próxima página.',
  inbox_error_load: 'Não foi possível carregar o box.',
  inbox_rate_limit: 'Muitas requisições — aguarde um momento.',
  inbox_toggle_error: 'Não foi possível alterar o status do box.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Me escreva anonimamente',
  message_placeholder: 'Escreva uma mensagem…',
  message_anonymous_hint: 'Sua mensagem será enviada anonimamente.',
  message_sent_title: 'Enviado ✅',
  message_sent_desc: 'Sua mensagem anônima foi entregue.',
  message_owner_entry: 'Me escreva',
  message_share_hint: 'Compartilhe o link para que qualquer pessoa possa te enviar uma mensagem anônima.',
  message_inbox_open: 'Mensagens recebidas',
  message_inbox_title: 'Mensagens',
  message_inbox_empty: 'Ainda sem mensagens. Compartilhe seu link acima.',

  // ANSWER SCREEN
  answer_title: 'Responder a pergunta',
  answer_placeholder: 'Escreva sua resposta…',
  answer_submit: 'Enviar',
  answer_submitting: 'Enviando…',
  answer_back: 'Voltar',
  answer_error_send: 'Não foi possível enviar a resposta.',

  // SHARE SCREEN
  share_title: 'Resposta publicada ✅',
  share_hint: 'Compartilhe o card e receba ainda mais perguntas.',
  share_card_rendering_desc:
    'O card ainda está sendo gerado. Volte para as perguntas e confira em breve — você poderá compartilhá-lo em uma Story ou via chat.',
  share_card_alt: 'Card de resposta',
  share_story_btn: 'Compartilhar na Story',
  share_story_btn_busy: 'Abrindo…',
  share_chat_btn: 'Compartilhar no chat',
  share_chat_btn_busy: 'Preparando…',
  share_back: 'Voltar às perguntas',
  share_story_unsupported:
    'Stories não estão disponíveis nesta versão do Telegram. Tente "Compartilhar no chat".',
  share_story_error: 'Não foi possível abrir a Story. Tente "Compartilhar no chat".',
  share_chat_sent: 'Mensagem enviada.',
  share_chat_unsupported:
    'Compartilhamento via chat não está disponível nesta versão do Telegram. Atualize seu cliente.',
  share_chat_error: 'Não foi possível compartilhar. Tente novamente.',
  share_chat_prepare_error: 'Não foi possível preparar a mensagem.',

  // LEADERBOARD SCREEN
  lb_title: 'Ranking',
  lb_period_7d: '7 dias',
  lb_period_30d: '30 dias',
  lb_period_all: 'Todo o período',
  lb_group_label: 'Categoria',
  lb_group_all: 'Todos',
  lb_group_ask: 'Perguntas',
  lb_group_rate: 'Avaliações',
  lb_group_confession: 'Confissões',
  lb_group_guesswho: 'Adivinhe quem',
  lb_group_message: 'Mensagens',
  lb_error: 'Não foi possível carregar o ranking',
  lb_empty: 'Ninguém no ranking ainda',
  lb_anon: 'Anônimo',
  lb_load_more: 'Carregar mais',
  lb_questions: (n) => plural('pt-br', n, { one: '{n} pergunta', other: '{n} perguntas' }),
  lb_referrals: (n) => plural('pt-br', n, { one: '{n} ref.', other: '{n} refs.' }),

  // REWARDS SCREEN
  rw_title: 'Minhas recompensas',
  rw_error: 'Não foi possível carregar as recompensas',
  rw_level: (n) => `Nível ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('pt-br', n, { one: '{n} indicação confirmada', other: '{n} indicações confirmadas' }),
  rw_next_level_section: (n) =>
    plural('pt-br', n, { one: 'PRÓXIMO NÍVEL — {n} indicação', other: 'PRÓXIMO NÍVEL — {n} indicações' }),
  rw_to_level: (level, target) => `para o nível ${level}: ${target}`,
  rw_max_level: 'Nível máximo atingido!',
  rw_badges_section: 'CONQUISTAS',
  rw_formats_section: 'FORMATOS DE BOX',

  // QUESTION CARD
  qcard_status_new: 'Nova',
  qcard_status_hidden: 'Oculta',
  qcard_status_answered: 'Respondida',
  qcard_moderation_flagged: 'Atenção: mensagem suspeita',
  qcard_answer_btn: 'Responder',
  qcard_answer_send: 'Enviar',
  qcard_share_btn: 'Compartilhar',
  qcard_hide_btn: 'Ocultar',
  qcard_show_btn: 'Mostrar',
  qcard_report_btn: 'Denunciar',
  qcard_block_btn: 'Bloquear',
  qcard_unblock_btn: 'Desbloquear',
  qcard_report_reason_label: 'Selecione o motivo da denúncia:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Assédio',
  qcard_reason_sexual: 'Conteúdo sexual',
  qcard_reason_other: 'Outro',
  qcard_error_hide: 'Não foi possível alterar a visibilidade.',
  qcard_error_report: 'Não foi possível enviar a denúncia.',
  qcard_error_block: 'Não foi possível bloquear o remetente.',
  qcard_report_done: 'Denúncia enviada — obrigado.',
  qcard_block_done: 'Remetente bloqueado.',
  qcard_unblock_done: 'Remetente desbloqueado.',

  // ERRORS
  err_network: 'Sem conexão com o servidor. Verifique sua internet e tente novamente.',
  err_server_unavailable: 'O servidor está temporariamente indisponível, tente novamente mais tarde.',
  err_internal: 'Algo deu errado do nosso lado. Já estamos verificando — tente novamente mais tarde.',
  err_bad_request: 'Verifique os dados que você inseriu.',
  err_generic: 'Não foi possível concluir a ação, tente novamente mais tarde.',
  err_schema: 'Erro nos dados. Tente atualizar o app.',
  share_story_link_premium_note:
    'Um link clicável nas Stories exige Telegram Premium. Sem ele, seus amigos ainda podem te encontrar — seu usuário está exibido no card.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Erro de acesso',
  auth_error_desc:
    'Falha na autenticação. Feche e reabra o Mini App pelo Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Nova recompensa!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Perguntas',
  tab_leaderboard: 'Ranking',
  tab_rewards: 'Recompensas',
  tab_settings: 'Configurações',

  // SETTINGS SCREEN
  settings_title: 'Configurações',
  settings_section_general: 'Geral',
  settings_notifications: 'Notificações de novas perguntas',
  settings_notifications_hint: 'O bot vai te avisar quando alguém fizer uma pergunta.',
  settings_notifications_error: 'Não foi possível salvar a configuração de notificação.',
  settings_language: 'Idioma',
  settings_language_error: 'Não foi possível alterar o idioma. Tente novamente.',
  settings_section_about: 'Sobre',
  settings_version: 'Versão',

  // CODE ENTRY (work-020)
  code_modal_title: 'Links nas Stories são exclusivos para Premium',
  code_modal_explain:
    'O Telegram só fornece link clicável nas Stories para assinantes Premium. Em vez disso, adicione seu código à story — os visitantes digitam no app e te fazem uma pergunta anônima.',
  code_modal_your_code: 'Seu código',
  code_modal_copy: 'Copiar código',
  code_modal_copied: 'Copiado',
  code_modal_share_btn: 'Compartilhar na story',
  code_modal_loading: 'Buscando seu código…',
  code_modal_error: 'Não foi possível obter seu código. Tente mais tarde.',
  ask_code_title: 'Insira um código',
  ask_code_desc:
    'Veio de uma story? Encontre o código nela (ex. 1234) e digite abaixo.',
  ask_code_placeholder: 'Código da story',
  ask_code_find: 'Buscar',
  ask_code_not_found: 'Código não encontrado. Confira os dígitos e tente novamente.',
  ask_code_invalid: 'O código tem 4 dígitos.',
  code_onboarding_header: 'Veio de uma story?',
  code_onboarding_text: 'Digite o código de um amigo para fazer uma pergunta anônima.',
  code_onboarding_action: 'Inserir código',
  settings_ask_by_code: 'Perguntar por código',
  settings_my_code_title: 'Seu código para stories',
  settings_my_code_hint:
    'Escreva este código na sua story — os visitantes digitam para te fazer uma pergunta anônima. O Telegram só oferece links clicáveis nas Stories para assinantes Premium.',
  settings_my_code_rotate: 'Obter novo código',
  settings_my_code_rotating: 'Atualizando…',
  settings_my_code_done: 'Código atualizado',
  settings_my_code_error: 'Não foi possível obter seu código.',
  settings_my_code_rotate_confirm_title: 'Trocar seu código?',
  settings_my_code_rotate_confirm_desc:
    'Seu código antigo para de funcionar na hora. Quem viu ele no seu story não vai mais conseguir te achar. Só troque se alguém estiver te enchendo com spam.',
  settings_my_code_rotate_confirm_action: 'Trocar código',

  // BOT
  bot_greeting: (name) => (name ? `Oi, ${name}! 👋` : 'Oi! 👋'),
  bot_onboarding:
    'Isso é o VeylMe — perguntas anônimas.\n\n' +
    'Abra o Mini App, publique um card «Me pergunte anonimamente» na sua Story — ' +
    'e receba perguntas anônimas direto aqui.\n\n' +
    '⚠️ 18+. Seja respeitoso: bullying, ameaças e conteúdo proibido ' +
    'não são permitidos. Anonimato ≠ impunidade — violações vão para moderação.',
  bot_open_btn: 'Abrir VeylMe',
  notify_answer_btn: 'Responder',
  bot_invite_text:
    'Alguém compartilhou um link do VeylMe.\n\n' +
    'Abra o Mini App para fazer uma pergunta anônima:',
  bot_invite_btn: 'Perguntar anonimamente',

  // WORK-027 i18n sweep
  tagline: 'Me pergunte anonimamente',
  share_ask_action: 'Perguntar',
  share_answered_text: 'Respondi uma pergunta anônima 👀',
  err_not_in_telegram: 'O Mini App não está rodando no Telegram. Reinicie o app.',
  badge_viral_starter: 'Início viral',
  badge_storyteller: 'Contador de histórias',
  badge_loop_master: 'Mestre do ciclo',
  theme_confession: 'Confissões',
  theme_guesswho: 'Adivinhe quem',
  rw_format_named: (name) => `formato «${name}»`,
  card_label_question: 'Pergunta',
  card_label_answer: 'Resposta',
  card_invite_subtitle: 'anônimo, sem cadastro',
  card_code_hint: 'DIGITE O CÓDIGO NO APP',
  share_msg_title: (brand) => `${brand} · Perguntas anônimas`,
  notify_new_question: '🔔 Alguém te fez uma pergunta anônima',
  notify_unanswered_reminder: (n) =>
    plural('pt-br', n, { one: '🔔 Você tem {n} pergunta sem resposta', other: '🔔 Você tem {n} perguntas sem resposta' }),
  notify_ban_permanent: 'permanentemente',
  notify_ban_until: (date) => `até ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Você está bloqueado no VeylMe ${untilPhrase}. Muitos destinatários denunciaram suas mensagens.\nSe você acha que isso é um engano, pode enviar um recurso no app.`,
  notify_warning_msg:
    '⚠️ Vários destinatários denunciaram suas mensagens. Mais um pouco e você será bloqueado no VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'Minhas perguntas',
  my_questions_empty_title: 'Você ainda não fez nenhuma pergunta',
  my_questions_empty_desc: 'Faça uma pergunta na caixa de alguém — a resposta vai aparecer aqui.',
  my_questions_loading: 'Verificando a resposta…',
  my_questions_waiting: 'Aguardando resposta',
  my_questions_answer_label: 'Resposta',
  settings_my_questions: 'Minhas perguntas',
  ask_sent_find_reply_hint: 'Você poderá encontrar a resposta depois em «Minhas perguntas».',
  inbox_story_nonpremium_hint: 'Um link de Story não é clicável sem Telegram Premium, por isso mostramos um código — compartilhar no chat é mais confiável.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Seu acesso do Telegram expirou',
  session_expired_desc: 'O Telegram dá o acesso ao app só uma vez, na abertura, e esse já expirou. Abra o app de novo — o texto que você começou a gente guardou.',
  session_expired_desc_no_storage: 'Seu acesso ao Telegram expirou e o app precisa ser reaberto. Não conseguimos salvar o texto que você digitou — copie antes de sair.',
  session_expired_reopen: 'Abrir de novo',
  session_expired_stuck_title: 'O Telegram devolveu o mesmo acesso antigo',
  session_expired_stuck_desc: 'Feche o app por completo pelo menu do bot e abra de novo — aí o Telegram vai dar um acesso novo.',
  session_auth_failed_title: 'Não foi possível confirmar sua entrada',
  session_auth_failed_desc: 'O Telegram não confirmou sua entrada no app. Feche o app e abra de novo pelo chat com o bot.',
  session_expired_manual_close: 'O app não consegue se fechar sozinho aqui — feche você mesmo e abra de novo pelo chat com o bot.',
  session_expiring_soon: 'Seu acesso do Telegram vai expirar em breve. Abra o app de novo para não perder nada.',
  my_questions_check_failed: 'Não foi possível verificar as respostas. Tente mais tarde.',
  settings_notifications_load_error: 'Não foi possível carregar a configuração.',
};
